import { ComponentProps, ReactNode } from 'react';

import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import Tooltip from 'design-system/components/Tooltip';

type LearnMoreTooltipProps = {
  tooltipContent: ReactNode;
  onClick: () => void;
};
const LearnMoreTooltip = ({
  tooltipContent,
  onClick,
  ...tooltipProps
}: LearnMoreTooltipProps & ComponentProps<typeof Tooltip>) => {
  return (
    <Tooltip {...tooltipProps}>
      <div style={{ maxWidth: '350px', whiteSpace: 'pre-wrap' }}>
        {tooltipContent}
        <Spacer height={2} />
        <Button width='full' onClick={onClick}>
          Learn More
        </Button>
      </div>
    </Tooltip>
  );
};

export default LearnMoreTooltip;
